export const translations = {
  en: {
    title: "Let's get you back on track",
    subtitle: "We couldn't find that page, but your health journey continues.",
    message: "Don't worry — this happens sometimes. Your care team is still here for you, and we'll help you find what you need.",
    reassurance: "Your health matters to us. Let's get you back quickly.",
    buttons: {
      home: "Return Home",
      newQuestionnaire: "Start Health Check",
      support: "Message Support",
      caseManager: "Contact Your Provider",
      reportIssue: "Report This Issue"
    },
    whatsapp: "Chat on WhatsApp",
    messenger: "Chat on Messenger",
    reportSent: "Thank you! We've logged this issue.",
    loading: "Finding your way...",
    didYouMean: "Were you looking for:",
    successMessage: "Found your way back! ✅",
    commonLinks: {
      newAssessment: "Start a new health assessment",
      checkStatus: "Check your case status",
      learnMore: "Learn about Tibbbi"
    }
  },
  ar: {
    title: "دعنا نساعدك في العودة إلى المسار الصحيح",
    subtitle: "يبدو أن هذه الصفحة غير متاحة حالياً، لكن رحلتك الصحية مستمرة معنا.",
    message: "لا داعي للقلق — نحن هنا لمساعدتك. فريق الرعاية الصحية الخاص بك جاهز لخدمتك، وسنوجهك إلى ما تحتاج إليه.",
    reassurance: "صحتك أولويتنا. نحن معك في كل خطوة.",
    buttons: {
      home: "العودة للرئيسية",
      newQuestionnaire: "بدء الفحص الصحي",
      support: "مراسلة الدعم",
      caseManager: "اتصل بمقدم الرعاية",
      reportIssue: "الإبلاغ عن هذه المشكلة"
    },
    whatsapp: "المحادثة على واتساب",
    messenger: "المحادثة على ماسنجر",
    reportSent: "شكراً لك! لقد سجلنا هذه المشكلة.",
    loading: "نبحث عن طريقك...",
    didYouMean: "هل كنت تبحث عن:",
    successMessage: "عدت إلى المسار الصحيح! ✅",
    commonLinks: {
      newAssessment: "بدء تقييم صحي جديد",
      checkStatus: "التحقق من حالة طلبك",
      learnMore: "تعرف على طبّي"
    }
  },
  he: {
    title: "בואו נחזיר אתכם למסלול",
    subtitle: "לא מצאנו את הדף הזה, אבל המסע הבריאותי שלך ממשיך.",
    message: "אל תדאגו — זה קורה לפעמים. צוות הטיפול שלכם עדיין כאן בשבילכם, ונעזור לכם למצוא את מה שאתם צריכים.",
    reassurance: "הבריאות שלך חשובה לנו. בואו נחזיר אתכם במהירות.",
    buttons: {
      home: "חזרה לדף הבית",
      newQuestionnaire: "התחל בדיקת בריאות",
      support: "שלח הודעה לתמיכה",
      caseManager: "צור קשר עם הספק שלך",
      reportIssue: "דווח על בעיה זו"
    },
    whatsapp: "צ'אט בוואטסאפ",
    messenger: "צ'אט במסנג'ר",
    reportSent: "תודה! רשמנו את הבעיה הזו.",
    loading: "מוצאים את הדרך שלך...",
    didYouMean: "האם חיפשת:",
    successMessage: "חזרת למסלול! ✅",
    commonLinks: {
      newAssessment: "התחל הערכה בריאותית חדשה",
      checkStatus: "בדוק את סטטוס הבקשה שלך",
      learnMore: "למד על טיבבי"
    }
  },
  fr: {
    title: "Remettons-vous sur la bonne voie",
    subtitle: "Nous n'avons pas trouvé cette page, mais votre parcours de santé continue.",
    message: "Ne vous inquiétez pas — cela arrive parfois. Votre équipe de soins est toujours là pour vous, et nous vous aiderons à trouver ce dont vous avez besoin.",
    reassurance: "Votre santé nous tient à cœur. Revenons rapidement.",
    buttons: {
      home: "Retour à l'accueil",
      newQuestionnaire: "Commencer le bilan de santé",
      support: "Contacter le support",
      caseManager: "Contacter votre prestataire",
      reportIssue: "Signaler ce problème"
    },
    whatsapp: "Discuter sur WhatsApp",
    messenger: "Discuter sur Messenger",
    reportSent: "Merci! Nous avons enregistré ce problème.",
    loading: "Recherche de votre chemin...",
    didYouMean: "Recherchiez-vous:",
    successMessage: "Vous êtes de retour sur la bonne voie! ✅",
    commonLinks: {
      newAssessment: "Commencer une nouvelle évaluation de santé",
      checkStatus: "Vérifier le statut de votre demande",
      learnMore: "En savoir plus sur Tibbbi"
    }
  },
  es: {
    title: "Volvamos a ponerte en el camino correcto",
    subtitle: "No encontramos esa página, pero tu camino hacia la salud continúa.",
    message: "No te preocupes — esto sucede a veces. Tu equipo de atención sigue aquí para ti y te ayudaremos a encontrar lo que necesitas.",
    reassurance: "Tu salud nos importa. Te ayudaremos a regresar rápidamente.",
    buttons: {
      home: "Volver al inicio",
      newQuestionnaire: "Iniciar chequeo de salud",
      support: "Contactar con soporte",
      caseManager: "Contactar a tu proveedor",
      reportIssue: "Informar de este problema"
    },
    whatsapp: "Chatear en WhatsApp",
    messenger: "Chatear en Messenger",
    reportSent: "¡Gracias! Hemos registrado este problema.",
    loading: "Buscando tu camino...",
    didYouMean: "¿Estabas buscando:",
    successMessage: "¡Encontraste el camino de regreso! ✅",
    commonLinks: {
      newAssessment: "Comenzar una nueva evaluación de salud",
      checkStatus: "Consultar el estado de tu caso",
      learnMore: "Aprender más sobre Tibbbi"
    }
  },
  de: {
    title: "Lass uns dich wieder auf Kurs bringen",
    subtitle: "Wir konnten diese Seite nicht finden, aber deine Gesundheitsreise geht weiter.",
    message: "Keine Sorge — das passiert manchmal. Dein Betreuungsteam ist weiterhin für dich da und wir helfen dir, das zu finden, was du brauchst.",
    reassurance: "Deine Gesundheit liegt uns am Herzen. Lass uns dich schnell zurückbringen.",
    buttons: {
      home: "Zur Startseite",
      newQuestionnaire: "Gesundheitscheck starten",
      support: "Support kontaktieren",
      caseManager: "Deinen Anbieter kontaktieren",
      reportIssue: "Dieses Problem melden"
    },
    whatsapp: "Auf WhatsApp chatten",
    messenger: "Auf Messenger chatten",
    reportSent: "Danke! Wir haben dieses Problem erfasst.",
    loading: "Wir suchen deinen Weg...",
    didYouMean: "Meintest du:",
    successMessage: "Weg zurück gefunden! ✅",
    commonLinks: {
      newAssessment: "Neue Gesundheitsbewertung starten",
      checkStatus: "Status deines Falls überprüfen",
      learnMore: "Mehr über Tibbbi erfahren"
    }
  },
  hi: {
    title: "आइए आपको वापस सही राह पर लाते हैं",
    subtitle: "हम वह पृष्ठ नहीं ढूंढ पाए, लेकिन आपकी स्वास्थ्य यात्रा जारी है।",
    message: "चिंता न करें — ऐसा कभी-कभी हो जाता है। आपकी देखभाल टीम अभी भी आपके साथ है और हम आपको वह ढूँढ़ने में मदद करेंगे जिसकी आपको ज़रूरत है।",
    reassurance: "आपकी सेहत हमारे लिए महत्वपूर्ण है। चलिए आपको जल्दी वापस लाते हैं।",
    buttons: {
      home: "मुख पृष्ठ पर लौटें",
      newQuestionnaire: "स्वास्थ्य जांच शुरू करें",
      support: "सहयोग से संपर्क करें",
      caseManager: "अपने प्रदाता से संपर्क करें",
      reportIssue: "इस समस्या की रिपोर्ट करें"
    },
    whatsapp: "WhatsApp पर चैट करें",
    messenger: "Messenger पर चैट करें",
    reportSent: "धन्यवाद! हमने इस समस्या को दर्ज कर लिया है।",
    loading: "आपका रास्ता ढूंढ रहे हैं...",
    didYouMean: "क्या आप यह ढूंढ रहे थे:",
    successMessage: "आपका रास्ता वापस मिल गया! ✅",
    commonLinks: {
      newAssessment: "नई स्वास्थ्य मूल्यांकन शुरू करें",
      checkStatus: "अपने केस की स्थिति जांचें",
      learnMore: "Tibbbi के बारे में जानें"
    }
  },
  zh: {
    title: "让我们帮你重回正轨",
    subtitle: "我们找不到该页面，但你的健康之旅仍在继续。",
    message: "别担心 — 这种情况偶尔会发生。你的护理团队仍然在这里，我们会帮助你找到所需的内容。",
    reassurance: "你的健康对我们很重要。让我们快速帮助你回到正轨。",
    buttons: {
      home: "返回首页",
      newQuestionnaire: "开始健康检查",
      support: "联系支持",
      caseManager: "联系您的提供者",
      reportIssue: "报告此问题"
    },
    whatsapp: "在 WhatsApp 上聊天",
    messenger: "在 Messenger 上聊天",
    reportSent: "谢谢！我们已记录此问题。",
    loading: "正在为你寻找路径...",
    didYouMean: "你是不是在找：",
    successMessage: "已找到回路！✅",
    commonLinks: {
      newAssessment: "开始新的健康评估",
      checkStatus: "查看你的案例状态",
      learnMore: "了解更多关于 Tibbbi"
    }
  }
};